import { Spin } from "antd"
import { useQuery } from "@tanstack/react-query"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { fetchMe } from "../features/tiles/api.js"
import { ApiError } from "../shared/api/request.js"

export function RequireAuth() {
  const location = useLocation()
  const { isPending, error } = useQuery({
    queryKey: ["auth", "me"],
    queryFn: ({ signal }) => fetchMe(signal),
    retry: false,
    staleTime: 10 * 60_000,
  })

  if (isPending)
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <Spin size="large" />
      </div>
    )

  if (error instanceof ApiError && error.status === 401)
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />

  return <Outlet />
}
